var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sectionTitle line"},[_vm._v("경기장 안전 가이드라인")]),_c('div',{staticClass:"indexBox waitingSeason",staticStyle:{"margin-top":"80px"}},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/img/ticket/guide_2024.jpg"),"alt":""}})])])])
}]

export { render, staticRenderFns }